module.exports = __webpack_public_path__ + "static/media/ipad-portfolio.6a5a6edf.jpg";